import { SkuData } from '@scenes/LocationPage/locationPage.types';

export const makeSpecificItemJsonLd = (skuData?: SkuData) => {
  if (!skuData) return null;

  return {
    description: skuData.meta.description,
    priceRange: `from ${skuData.startsAtPrice}`,
  };
};
